import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold" }, "Fläche:", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("m²")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Stück")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("mtr")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("kWp")

import { useAddProject } from '@/store/addProject'
import { IonSelect, IonSelectOption } from '@ionic/vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'AreaInput',
  setup(__props) {

const addProjectStore = useAddProject()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass(["w-full min-min-h-10 h-10 my-1 bg-zewotherm-lightgrey placeholder-zewotherm-grey font-bold rounded-lg outline-none flex", [_unref(addProjectStore).errorResponse.area && _unref(addProjectStore).errorResponse.area.length > 0 || _unref(addProjectStore).errorResponse.area_unit && _unref(addProjectStore).errorResponse.area_unit.length > 0  ? 'border-2 border-red-500' : '']])
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "number",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(addProjectStore).projectActiveData.area) = $event)),
        enterkeyhint: "next",
        class: "w-0 flex-grow h-full bg-zewotherm-lightgrey p-2 font-bold rounded-lg outline-none"
      }, null, 512), [
        [_vModelText, _unref(addProjectStore).projectActiveData.area]
      ]),
      _createVNode(_unref(IonSelect), {
        interface: "popover",
        enterkeyhint: "next",
        modelValue: _unref(addProjectStore).projectActiveData.area_unit,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(addProjectStore).projectActiveData.area_unit) = $event)),
        class: "w-auto h-full bg-zewotherm-lightgrey p-2 font-bold rounded-lg outline-none text-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonSelectOption), {
            value: "m2",
            selected: ""
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_unref(IonSelectOption), { value: "piece" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_unref(IonSelectOption), { value: "mtr" }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_unref(IonSelectOption), { value: "kWp" }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(addProjectStore).errorResponse.area, (errorMsg, index) => {
      return (_openBlock(), _createElementBlock("p", {
        class: "text-red-500",
        key: index
      }, _toDisplayString(errorMsg), 1))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(addProjectStore).errorResponse.area_unit, (errorMsg, index) => {
      return (_openBlock(), _createElementBlock("p", {
        class: "text-red-500",
        key: index
      }, _toDisplayString(errorMsg), 1))
    }), 128))
  ]))
}
}

})